import { AvailableTypeEnum } from '../attributes/attributes';

export const SUPPORTED_FIELD_TYPES_FOR_IMPORT = [
    AvailableTypeEnum.text,
    AvailableTypeEnum.number,
    AvailableTypeEnum.boolean,
    AvailableTypeEnum.date,
    AvailableTypeEnum.note,
    AvailableTypeEnum.reference
]
